// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2021-04-27 11:28:26 +0200 (Tue, 27 Apr 2021) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 118782 $
//  Purpose   : auth support
// =============================================================================
export const parts = true

export {sagas} from './sagas'

import * as actions from './actions'
export {actions}

import * as reducers from './reducers'
export {reducers}

import {includes} from 'ldash'
export const hasGroup = ({dname, user, name}) => {
  // check if current user is in group
  return (
    user &&
    (includes(user.groups, name) ||
      (dname && user.localgroups && includes(user.localgroups[dname], name)))
  )
}

const views = {
  // non-server-side routed view for loginDialog
  // could alternativly solved directly in templating/view.js
  xauth: {
    tabs: {
      loginDialog: {
        tabGroup: null,
        parts: ['AuthLogin'],
        layout: 'blank',
      },
    },
  },
}

export {views}
